<template>
  <div class="homeWrap">
      <router-view/>
  </div>
</template>

<script>
// import {json,wordData,utils} from '@/common/common.js'
export default {
  name: 'HelloWorld',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    .homeWrap{
        .ceshi{color:red;}
    }
</style>



// WEBPACK FOOTER //
// src/pages/system/frame.vue